import { PAGE_TYPE } from '../../../features/base/app/constants';
import JitsiMeetJS, { JitsiConnectionEvents } from '../../../features/base/lib-jitsi-meet';
import senderHealth from './senderHealth';

class JitsiConnection {
	constructor() {
		this.connection = null;
		this.connecting = false;
		this._intentionalDisconnect = false;
	}

	/**
	 * 연결 성립 후의 시그널링 상태 감시. 종전에는 CONNECTION_DISCONNECTED/INTERRUPTED 핸들러가 주석 처리되어
	 * 세션 중 XMPP 가 끊겨도 앱은 아무것도 몰랐다. lib(Strophe)가 소켓을 스스로 재개하므로(실측 2초 내)
	 * 여기서는 재접속을 직접 하지 않고 senderHealth 에 알려 유예 후 판정하게 한다.
	 */
	_watch(connection) {
		const ev = JitsiMeetJS.events.connection;
		const onDisconnected = () => {
			if (this._intentionalDisconnect) return;
			senderHealth.onSignaling('disconnected');
		};
		const onFailed = (error) => {
			if (this._intentionalDisconnect) return;
			senderHealth.onSignaling(`failed:${error || ''}`);
		};
		const onEstablished = () => senderHealth.onSignaling('established');

		connection.addEventListener(ev.CONNECTION_DISCONNECTED, onDisconnected);
		connection.addEventListener(ev.CONNECTION_FAILED, onFailed);
		connection.addEventListener(ev.CONNECTION_ESTABLISHED, onEstablished);
		this._unwatch = () => {
			connection.removeEventListener(ev.CONNECTION_DISCONNECTED, onDisconnected);
			connection.removeEventListener(ev.CONNECTION_FAILED, onFailed);
			connection.removeEventListener(ev.CONNECTION_ESTABLISHED, onEstablished);
			this._unwatch = null;
		};
	}

	// jitsi 연결
	connect(config) {
		if (this.connection) {
			// 이미 연결 되어있는 상태
			return;
		}

		if (this.connecting) {
			// 연결 중인 상태
			return;
		}

		// this.connecting = true;
		// jitsi websocket connect
		const connection = new JitsiMeetJS.JitsiConnection(null, null, config);

		// 연결 이벤트 등록
		return new Promise((resolve, reject) => {
			connection.addEventListener(
				JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED,
				handleConnectionEstablished,
			);
			connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_FAILED, handleConnectionFailed);
			// connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_DISCONNECTED, retryConnection);
			// connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_INTERRUPTED, retryConnection);

			const self = this;
			function handleConnectionEstablished() {
				// connection
				self.connection = connection;
				self.connecting = false;
				self._intentionalDisconnect = false;
				// 이벤트 삭제
				unsubscribe();
				// 세션 중 시그널링 상태 감시 시작
				self._watch(connection);

				resolve(connection);
			}

			function handleConnectionFailed(error, message, credentials, details) {
				// (수정) 종전엔 여기서 `this` 가 undefined(strict 모드 일반 함수)라 TypeError 로 죽어
				// reject 가 호출되지 않았고, 최초 연결 실패 시 입장 프라미스가 영원히 대기했다.
				self.connection = null;
				self.connecting = false;
				// 연결 실패
				connection.removeEventListener(JitsiConnectionEvents.CONNECTION_FAILED, handleConnectionFailed);

				reject(error);
			}

			function unsubscribe() {
				connection.removeEventListener(
					JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED,
					handleConnectionEstablished,
				);

				connection.removeEventListener(JitsiMeetJS.events.connection.CONNECTION_FAILED, handleConnectionFailed);
			}

			this.connection = connection;
			connection.connect();
		});
	}

	// jitsi 연결 끊기 (의도된 종료 — 감시 모듈에 끊김으로 보고하지 않는다)
	disconnect() {
		if (this.connection) {
			this._intentionalDisconnect = true;
			this._unwatch && this._unwatch();
			this.connection.disconnect();

			this.connection = null;
			this.connecting = false;
		}
	}
}

export default JitsiConnection;
